import React, { useEffect, useState } from 'react';
import { X } from 'react-bootstrap-icons';

export function ProductList({ products, onChangeProductQuantity, onRemoveProduct, onChangePrestation, onChangeRemise, onChangePrix }) {
    return (
        <table className="table table-striped-hover table-sm">
            <thead>
                <tr>
                    <th scope="col">CODE</th>
                    <th scope="col">DESIGNATION</th>
                    <th scope="col">PRIX VENTE</th>
                    <th scope="col">QUANTITÉ</th>
                    <th scope="col">REMISE</th>
                    <th scope="col">#</th>
                </tr>
            </thead>
            <tbody>
                {products.map((product, index) => {
                    return (
                        <tr key={index} hover="true">
                            <td>{product.qrbarre}</td>
                            <td>
                                <input
                                    type="text"
                                    className="prestation"
                                    value={product.descriptionart}
                                    disabled
                                    // onChange={(event) => onChangePrestation(index, event)}
                                />
                            </td>
                            <td>
                                <input
                                    type="number"
                                    className="prix"
                                    step="any"
                                    value={product.prix}
                                    // onChange={(event) => onChansgePrix(index, event)}
                                    disabled
                                />
                            </td>
                            <td>
                                <input
                                    type="number"
                                    className="prix"
                                    step="any"
                                    value={product.quantite}
                                    onChange={(event) => onChangeProductQuantity(index, event)}
                                />
                            </td>

                            <td>
                                <input
                                    type="number"
                                    className="quantity"
                                    step="any"
                                    value={product.remise}
                                    onChange={(event) => onChangeRemise(index, event)}
                                />
                            </td>
                            <td>
                                <X color="red" size={20} onClick={() => onRemoveProduct(index, product)}></X>
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
}

export function Summary({ listeSelect, sitva, type_remise, remise_main }) {
    const [totaux, setTotaux] = useState({
        totalHT: 0,
        totalRemise: 0
    });
    const { totalHT, totalRemise } = totaux;
    useEffect(() => {
        let totalHT = 0;
        let totalRemise = 0;
        let qte = 0;
        listeSelect.forEach((item) => {
            const { prix, quantite, remise } = item;
            qte += prix;
            // console.log(quantite);
            const montantHT = prix * quantite;
            // console.log(prix);
            const valeurRemise = ((prix * remise) / 100) * quantite;
            totalHT += montantHT;
            totalRemise += valeurRemise;
        });
        console.log(totalHT);
        setTotaux({ totalHT, totalRemise });
    }, [listeSelect]);
    console.log(totalHT);
    var remise = remise_main > 0 ? (type_remise == 0 ? totalHT * (remise_main / 100) : remise_main) : 0;
    //console.log(remise);
    var total = totalHT - remise - totalRemise;
    const ht = total; // / (1 + 0.18);
    const tva = sitva == 0 ? ht * 0.18 : 0;
    total = ht + tva;
    return (
        <p id="lightr">
            Sans remise: <b>{formatCurrency(totalHT)} </b> || Remise: <b>{formatCurrency(remise + totalRemise)} </b> || Total HT:{' '}
            <b>{formatCurrency(ht)} </b>|| Total TVA {sitva == 1 ? 'exonéré' : ''}: <b>{formatCurrency(tva)} </b>|| Total TTC:{' '}
            <b>{formatCurrency(total)}</b>
        </p>
    );
}
function formatCurrency(value) {
    return new Intl.NumberFormat().format(Math.round(value));
}
